import styles from './hint-error.scss?inline';
import { LitElement, html, unsafeCSS, CSSResult } from 'lit';
import { property, query, queryAssignedElements } from 'lit/decorators.js';
import { IconComponent } from '../icon/icon';
import { iconService } from '../icon/icon.service';

IconComponent.define()
iconService.importStickersheet();

export class HintErrorComponent extends LitElement {
  static selector = `{{c11n-prefix}}-hint-error`;
  static override styles: CSSResult = unsafeCSS(styles);
  static define = (selector?: string) => {
    const componentSelector = selector || HintErrorComponent.selector;
    const isDeclared = customElements.get(componentSelector);
    if (!isDeclared) {
      customElements.define(componentSelector, HintErrorComponent);
    }
  }

  // Some attributes (error) were being stripped in Stencil apps,
  // but we found a simple workaround. If using @property 
  // we may need to differentiate the name from the attribute 
  // https://github.com/ionic-team/stencil/issues/2703

  @property({ attribute: 'error' , type: Boolean })
  _error?: boolean;

  @property({ attribute: 'c11n-web-hint-error', type: Boolean, reflect: true })
  readonly _c11n_web_hint_error: boolean = true;

  @query('.c11n-hint-error__container')
  hintErrorEl!: HTMLElement;

  @queryAssignedElements({ slot: 'error', selector: 'span' })
  errorEls!: Array<HTMLSpanElement>;

  @queryAssignedElements({ slot: 'hint', selector: 'span' })
  hintEls!: Array<HTMLSpanElement>;

  get errorEl() {
    return this.errorEls && this.errorEls[0];
  }

  get hintEl() {
    return this.hintEls && this.hintEls[0];
  }

  override connectedCallback(): void {
    super.connectedCallback();
  }

  override attributeChangedCallback(name: string, _old: string | null, value: string | null) {
    super.attributeChangedCallback(name, _old, value);
  }

  override render() {
    return html`
    <span class="c11n-hint-error__container">
      <span class="c11n-hint-error__hint">
        <span>
          <slot name="hint"></slot>
        </span>
      </span>
      <span class="c11n-hint-error__error">
        <{{c11n-prefix}}-icon name="error" class="c11n-hint-error__error__icon"></{{c11n-prefix}}-icon>
        <span>
          <strong>Error:&nbsp;</strong><slot name="error"></slot>
        </span>
      </span>
    </span>`;
  }
}
export const C11nHintError = HintErrorComponent.selector;
